// configures NextJS client runtime https://nextjs.org/docs/app/api-reference/file-conventions/instrumentation-client
//
// This file runs BEFORE React hydration, so we cannot use fetch() or getClientRuntimeConfig().
// Instead, we read the config from the inline <script id="__BNEF_CONFIG__"> tag injected by
// _document.tsx, which is present in the DOM before any bundle scripts execute.

;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.12";import * as Sentry from '@sentry/nextjs';
// replayIntegration, thirdPartyErrorFilterIntegration and captureRouterTransitionStart live on browser-only conditional
// entrypoint. oxlint's import resolver follows server entrypoint which doesn't have them, so it flags usages as errors
/* eslint-disable import/namespace */

// Parse config directly from the __BNEF_CONFIG__ DOM element.
// This element is a <script type="application/json"> tag rendered by _document.tsx,
// present in the DOM before any bundle scripts execute.
let bnefConfig: Record<string, any> = {};
try {
    const configEl = document.getElementById('__BNEF_CONFIG__');
    if (configEl?.textContent) {
        bnefConfig = JSON.parse(configEl.textContent);
    }
} catch (error) {
    // Safety: if parsing fails, Sentry initializes disabled (all values undefined/falsy).
    console.warn('Failed to parse __BNEF_CONFIG__ for Sentry config:', error);
}

const sentryConfig = bnefConfig.sentry || {};

Sentry.init({
    allowUrls: [/https:\/\/www\.bnef\.com/, /bloomberg\.com/],

    environment: bnefConfig.environment,
    release: bnefConfig.buildId,

    enabled: sentryConfig.enabled,
    dsn: sentryConfig.clientDsn ?? sentryConfig.dsn,
    tracesSampleRate: sentryConfig.tracesSampleRate,
    profilesSampleRate: sentryConfig.profilesSampleRate,

    integrations: [
        // Replay may only be enabled for the client-side
        Sentry.replayIntegration({
            maskAllText: false,
        }),
        Sentry.captureConsoleIntegration({
            levels: ['error'], // send only error to Sentry to keep the issues list cleaner
        }),
        Sentry.thirdPartyErrorFilterIntegration({
            // Specify the application keys that you specified in the Sentry bundler plugin
            filterKeys: ['bnef'],

            // Defines how to handle errors that contain third party stack frames.
            // Possible values are:
            // - 'drop-error-if-contains-third-party-frames'
            // - 'drop-error-if-exclusively-contains-third-party-frames'
            // - 'apply-tag-if-contains-third-party-frames'
            // - 'apply-tag-if-exclusively-contains-third-party-frames'
            behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
        }),
        Sentry.browserProfilingIntegration(),
    ],

    // Capture Replay for sessions with an error
    replaysOnErrorSampleRate: 1.0,

    // some errors not worth sending as they are not due to our application code
    ignoreErrors: [
        // logs due to user behaviour (pressing the browser stop/refresh button or clicking somewhere else) - not errors
        'The user aborted a request',
        'The operation was aborted',
        'Cancel rendering route',
        'Abort fetching component',
        'Loading initial props cancelled',
        'Route did not complete loading',

        // logs due to printing behaviour - out of band with our code so not an error, but noisy
        'Ignored window.print() because of a pending print job.',
        'Window.print: No browsing context',

        // user network issues, not our error
        'TypeError: Failed to fetch',
        'TypeError: NetworkError when attempting to fetch resource.',

        // Toaster
        'tea-sdk',
        'shoptagr',
        'Failed to parse event data',

        // Bloomberg Video player
        '[BVP]',
        'VIDEOJS',
        'Youbora',
        'cedexisAppID',
        'The play() request was interrupted', // https://bbgithub.dev.bloomberg.com/WSS/projector/issues/1544

        // Matomo
        'javaEnabled', // DRQS 178997790

        // Sailthru
        'Personalize call failed',
        'Invalid url: file:', // happens when a user saves a webpage to their machine

        // Outlook Link scanning https://github.com/getsentry/sentry-javascript/issues/3440#issuecomment-865857552
        'Non-Error promise rejection captured',

        // Blocked third parties, which have graceful fallbacks
        'Failed to load https://platform.twitter.com/widgets.js',

        // Mapbox
        'Failed to initialize WebGL',
        'Failed to fetch (api.mapbox.com)',
    ],
});
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
